import { Box, Divider, Paper, type BoxProps } from "@mui/material";
import type { PropsWithChildren } from "react";

// Large right padding is to reserve space for Intercom chat button

interface Props {
  containerProps?: BoxProps;
}

const GeneralPageFooter = ({ containerProps = {}, children }: PropsWithChildren<Props>) => {
  return (
    <Paper sx={{ position: "sticky", bottom: 0, left: "auto", right: 0, width: "100%", zIndex: 1100, borderRadius: 0 }}>
      <Divider />
      <Box
        {...containerProps}
        sx={[
          { py: 2, pl: 3, pr: 10, display: "flex", justifyContent: "space-between" },
          ...(Array.isArray(containerProps.sx) ? containerProps.sx : [containerProps.sx]),
        ]}
      >
        {children}
      </Box>
    </Paper>
  );
};

export default GeneralPageFooter;
